import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const CATS = [
  { slug: "", label: "Todos" },
  { slug: "rastreador", label: "Rastreadores" },
  { slug: "rele", label: "Relés" },
  { slug: "chicote", label: "Chicotes" },
  { slug: "acessorio", label: "Acessórios" },
];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const url = cat ? `/products?category=${cat}` : "/products";
    api.get(url).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 py-12 sm:py-16">
      <div className="text-center mb-12">
        <div className="text-xs uppercase tracking-widest font-quicksand font-bold text-[#1BB0CE] mb-3">
          CATÁLOGO
        </div>
        <h1 className="font-quicksand text-4xl sm:text-5xl font-extrabold text-[#3d3d3d]">
          Equipamentos disponíveis
        </h1>
        <p className="text-sm sm:text-base text-[#666] mt-4 max-w-xl mx-auto">
          Todos os equipamentos com nota fiscal, garantia e envio imediato.
        </p>
      </div>

      <div className="flex flex-wrap gap-2 mb-10 justify-center">
        {CATS.map((c) => (
          <button
            key={c.slug || "all"}
            data-testid={`filter-${c.slug || "all"}`}
            onClick={() => {
              if (c.slug) setParams({ cat: c.slug });
              else setParams({});
            }}
            className={`px-5 py-2.5 rounded-full font-quicksand text-sm font-bold transition-all ${
              cat === c.slug
                ? "bg-gp-gradient text-white shadow-md"
                : "bg-white text-[#3d3d3d] border border-[#e4e4e7] hover:border-[#1BB0CE] hover:text-[#1BB0CE]"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="card-soft p-5 h-96 animate-pulse" />
          ))}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 card-soft">
          <p className="text-sm text-[#666]">Nenhum produto encontrado nesta categoria.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
